import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { UIStore } from '@core/stores';
import { NgIconsModule, provideIcons } from '@ng-icons/core';
import { heroMoon, heroSun } from '@ng-icons/heroicons/outline';
import { SvgIconComponent } from '@shared/components';
import { DxTooltip } from '@v-ui';

@Component({
  selector: 'app-theme-toggle',
  standalone: true,
  imports: [CommonModule, NgIconsModule, SvgIconComponent, DxTooltip],
  templateUrl: './theme-toggle.component.html',
  styleUrls: ['./theme-toggle.component.css'],
  providers: [provideIcons({ heroSun, heroMoon })],
})
export class ThemeToggleComponent {
  uiStore = inject(UIStore);

  // Theme/DOM sync happens centrally in UIStore (onInit hook). The toggle only
  // flips the value here.
  toggleTheme() {
    this.uiStore.setTheme(this.uiStore.theme() === 'light' ? 'dark' : 'light');
  }
}
